import { render, staticRenderFns } from "./UbDropdown.vue?vue&type=template&id=806aa1aa&"
import script from "./UbDropdown.vue?vue&type=script&lang=js&"
export * from "./UbDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports